import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import LandingPage from "@/pages/LandingPage";
import AuthPage from "@/pages/AuthPage";
import AuthCallbackPage from "@/pages/AuthCallbackPage";
import DashboardLayout from "@/layouts/DashboardLayout";
import DashboardPage from "@/pages/DashboardPage";
import NewQuotePage from "@/pages/NewQuotePage";
import QuoteDetailPage from "@/pages/QuoteDetailPage";
import SavedQuotesPage from "@/pages/SavedQuotesPage";
import ClientsPage from "@/pages/ClientsPage";
import CompanyProfilePage from "@/pages/CompanyProfilePage";
import PricingPage from "@/pages/PricingPage";
import BillingSuccessPage from "@/pages/BillingSuccessPage";
import TemplatesPage from "@/pages/TemplatesPage";
import TemplateImportPage from "@/pages/TemplateImportPage";
import { useAuth } from "@/context/AuthContext";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route
        path="/app"
        element={
          <Protected>
            <DashboardLayout />
          </Protected>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="new" element={<NewQuotePage />} />
        <Route path="quotes" element={<SavedQuotesPage />} />
        <Route path="quotes/:id" element={<QuoteDetailPage />} />
        <Route path="clients" element={<ClientsPage />} />
        <Route path="templates" element={<TemplatesPage />} />
        <Route path="templates/import" element={<TemplateImportPage />} />
        <Route path="profile" element={<CompanyProfilePage />} />
        <Route path="billing/success" element={<BillingSuccessPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
